// extracted by mini-css-extract-plugin
export default {"topic":"NKXmcy"};